import { makeStyles } from '@material-ui/styles';

const HEADER_HEIGHT = 0;
const RESULTS_BAR_HEIGHT = 81;
const CONTROL_BAR_HEIGHT = 72;

export default makeStyles(theme => ({
  paper: {
    width: '100%',
    height: '100%',
  },
  header: {
    height: HEADER_HEIGHT,
    position: 'relative',
    padding: 24,
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderBottom: `1px solid ${theme.palette.colors.border}`,
  },
  backButton: {
    left: 10,
    position: 'absolute',
  },
  results: {
    height: RESULTS_BAR_HEIGHT,
    borderBottom: `1px solid ${theme.palette.colors.border}`,
    padding: 20,
    width: '100%',
  },
  controlBar: {
    height: CONTROL_BAR_HEIGHT,
    borderTop: `1px solid ${theme.palette.colors.border}`,
    padding: [theme.spacing(2), 20],
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  controlButton: {
    width: '45%',
  },
  quizContainer: {
    height: `calc(100% - ${HEADER_HEIGHT + RESULTS_BAR_HEIGHT + CONTROL_BAR_HEIGHT}px)`,
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    overflow: 'scroll',
    padding: [0, 20],
    '& .MuiTypography-h1': {
      fontSize: '20px',
    },
  },
}));



// WEBPACK FOOTER //
// ./src/sharedComponents/Quiz/components/MobileQuiz/useStyles.js